class FfVideoManager extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.ffVideosData = window.fantasticfy?.ffVideosData || [];
    if (!this.ffVideosData.length) return;

    this.ffVideosStates = this.ffVideosData.map((_, i) => i === 0);

    this.ffSelfHostedVideo = this.querySelector(".ff-self-hosted-video");
    this.ffSelfHostedVideoSource = this.ffSelfHostedVideo?.querySelector("source");
    this.ffExternalVideo = this.querySelector(".ff-external-video");
    this.ffTitle = this.querySelector(".ff-active-title");
    this.ffDescription = this.querySelector(".ff-active-description");
    this.ffSidebarVideos = this.querySelectorAll(".ff-video-container");
    this.ffVideoLink = this.querySelector(".ff-video-link");

    this.ffSetActiveVideo(0);
    this.#ffAttachClickEvents();
  }

  #ffAttachClickEvents() {
    this.ffSidebarVideos.forEach((el, index) => {
      el.addEventListener("click", () => this.ffSetActiveVideo(index));
    });
  }

  ffSetActiveVideo(index) {
    this.ffVideosStates = this.ffVideosStates.map((_, i) => i === index);

    this.ffSidebarVideos.forEach((el, i) => {
      el.style.display = i === index ? "none" : "flex";
    });

    const videoData = this.ffVideosData[index];
    this.#ffChangeTextContent(videoData);

    if (videoData.video_type === 'self-hosted video') {
      this.#ffSetSelfHostedVideo(videoData.videoSources[0]);
    } else {
      this.#ffSetExternalVideo(videoData);
    }
    this.ffVideoLink.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  #ffSetSelfHostedVideo(src) {
    if (!this.ffSelfHostedVideo || !this.ffSelfHostedVideoSource) return;

    this.ffSelfHostedVideoSource.src = src;
    this.ffSelfHostedVideo.load();

    const onReady = () => {
      this.ffSelfHostedVideo.currentTime = 2;
      this.#ffToggleVideoVisibility(true);
      this.ffSelfHostedVideo.removeEventListener('loadeddata', onReady);
    };

    this.ffSelfHostedVideo.addEventListener('loadeddata', onReady);
  }

  #ffSetExternalVideo(videoData) {
    const videoId = this.#ffGetExternalVideoId(videoData);
    if (!videoId) return;

    const base = videoData.external_video_selection === 'youtube'
      ? 'https://www.youtube.com/embed/'
      : 'https://player.vimeo.com/video/';
    const params = videoData.external_video_selection === 'youtube'
      ? '?enablejsapi=1&mute=1&playlist='
      : '?muted=1&playlist=';

    const onIframeLoad = () => {
      this.#ffToggleVideoVisibility(false);
      this.ffExternalVideo.removeEventListener('load', onIframeLoad);
    };
    this.ffExternalVideo.addEventListener('load', onIframeLoad);

    this.ffExternalVideo.src = `${base}${videoId}${params}${videoId}`;
  }

  #ffToggleVideoVisibility(isSelfHosted) {
    this.ffSelfHostedVideo.classList.toggle("ff-active-video", isSelfHosted);
    this.ffSelfHostedVideo.classList.toggle("ff-disabled-video", !isSelfHosted);
    this.ffExternalVideo.classList.toggle("ff-active-video", !isSelfHosted);
    this.ffExternalVideo.classList.toggle("ff-disabled-video", isSelfHosted);
  }

  #ffChangeTextContent({ title, description }) {
    this.ffTitle.innerHTML = title;
    if (this.ffDescription) this.ffDescription.innerHTML = description;
  }

  #ffGetExternalVideoId({ external_video, external_video_selection }) {
    if (!external_video) return null;
    return external_video_selection === 'youtube'
      ? external_video.split(/v=|\/embed\/|\.be\//)[1]?.split(/[?&]/)[0] || null
      : external_video.split(/vimeo\.com\/(?:video\/)?/)[1]?.split(/[?&]/)[0] || null;
  }
}

customElements.define('ff-video-manager', FfVideoManager);
